"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var http_1 = require("@angular/common/http");
var HttpOverdueWarningService = /** @class */ (function () {
    function HttpOverdueWarningService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.serviceUrl$ = Observable_1.Observable.fromPromise(this.applicationPropertiesService.getProperty('event-handler-service-url'));
    }
    HttpOverdueWarningService_1 = HttpOverdueWarningService;
    HttpOverdueWarningService.prototype.getOverdueEntities = function (category) {
        var _this = this;
        return this.serviceUrl$.switchMap(function (serviceUrl) {
            var url = HttpOverdueWarningService_1.OVERDUE_URL.replaceTemplate({
                serviceUrl: serviceUrl,
                category: category
            });
            return _this.http.get(url);
        });
    };
    HttpOverdueWarningService.prototype.getOverdueEntitiesDetails = function (category) {
        var _this = this;
        return this.serviceUrl$.switchMap(function (serviceUrl) {
            var url = HttpOverdueWarningService_1.OVERDUE_URL.replaceTemplate({
                serviceUrl: serviceUrl,
                category: category
            });
            return _this.http.get(url, { params: { view: 'detail' } });
        });
    };
    HttpOverdueWarningService.prototype.getOverdueEntitiesCount = function (category) {
        var _this = this;
        return this.serviceUrl$.switchMap(function (serviceUrl) {
            var url = HttpOverdueWarningService_1.OVERDUE_URL.replaceTemplate({
                serviceUrl: serviceUrl,
                category: category
            });
            return _this.http.get(url, { params: { view: 'count' } });
        });
    };
    var HttpOverdueWarningService_1;
    HttpOverdueWarningService.OVERDUE_URL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/normatives/entities/overdue/", ""], ["", "/normatives/entities/overdue/", ""])), 'serviceUrl', 'category');
    HttpOverdueWarningService = HttpOverdueWarningService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpOverdueWarningService);
    return HttpOverdueWarningService;
}());
exports.HttpOverdueWarningService = HttpOverdueWarningService;
var templateObject_1;
//# sourceMappingURL=http-overdue-warning.service.js.map